<template>
  <div v-if="resource !== 'Overflow'">
    <EventComponent
      v-for="(event, eventIndex) in chunk"
      :key="event.id"
      :event="event"
      :event-index="eventIndex"
      :date="_date"
      @delete-event="deleteEvent"
      @search-event="onSearchEvent"
    />
  </div>
  <div v-else>
    <div v-if="chunk.length < 2">
      <EventComponent
        v-for="(event, eventIndex) in chunk"
        :key="event.id"
        :event="event"
        :event-index="eventIndex"
        :date="_date"
        @delete-event="deleteEvent"
        @search-event="onSearchEvent"
      />
    </div>
    <div v-else>
      <div class="ec-event" :style="getGroupStyle(chunk)">
        <v-badge :content="chunk.length" color="red-darken-1">
          <CPopover placement="top" trigger="click">
            <template #toggler="{ on }">
              <v-btn
                variant="flat"
                size="x-small"
                color="light-blue-darken-1"
                v-on="on"
                >View List</v-btn
              >
            </template>
            <template #content>
              <v-card-text class="bg-grey-lighten-3 text-body-2">
                <EventComponent
                  v-for="(event, eventIndex) in chunk"
                  :key="event.id"
                  :event="event"
                  :event-index="eventIndex"
                  :date="_date"
                  @delete-event="deleteEvent"
                  @search-event="onSearchEvent"
                  :has-style="false"
                />
              </v-card-text>
            </template>
          </CPopover>
        </v-badge>
      </div>
    </div>
  </div>
</template>

<script setup>
import EventComponent from "./../EventComponent.vue";
import { CPopover } from "@coreui/vue";
import { watch, ref, onMounted } from "vue";
import { useEventStore } from "../../stores/EventStore";
import { useDateStore } from "../../stores/datestore";
import { useAppointmentStore } from "../../stores/appointmentsStore";
import { calculateTopMargin } from "../../libs/util";

import _ from "lodash";

const props = defineProps({
  chunk: {
    type: Array,
    required: true,
    default: () => [],
  },
  resource: {
    type: String,
    required: true,
    default: "",
  },
});

const eventStore = useEventStore();
const dateStore = useDateStore();
const appointmentsStore = useAppointmentStore();

const _date = ref(new Date());
const getGroupStyle = (chunk) => {
  let top = calculateTopMargin(_date.value, chunk[0], 0);
  return "top: " + top + "px; position:absolute;";
};
watch(
  () => dateStore.selectedDate,
  () => {
    _date.value = dateStore.selectedDate;
  },
  { immediate: true }
);

const deleteEvent = (event_id, cancellationNote = '') => {
  eventStore.removeEvent(event_id, cancellationNote);
};
const onSearchEvent = (event_id) => {
  appointmentsStore.$patch({
    barSearch: {
      isShowSearch: true,
      isNotesSearch: false,
      notesEventId: event_id,
    },
  });
};
</script>
